import isEqual from 'lodash/isEqual';

const haveArraysSameContent = (array1: any[], array2: any[]): boolean => {
  if (array1.length !== array2.length) return false;

  let result = true;

  array1.forEach((element) => {
    if (!array2.includes(element)) result = false;
  });

  return result;
};

export const putElementInFirstPosition = <T,>(array: T[], element: T): T[] => {
  const newArray = array.filter((e) => !isEqual(e, element));

  newArray.unshift(element);
  return newArray;
};

export const removeElementFromArray = <T,>(array: T[], element: T): T[] => {
  return array.filter((e) => !isEqual(e, element));
};

export default haveArraysSameContent;
